var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单页面快照",
        visible: _vm.centerDialogVisible,
        width: "30%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      JSON.stringify(_vm.datas) !== "{}"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "container",
            },
            [
              _c(
                "div",
                {
                  staticClass: "yuan",
                  on: {
                    click: function ($event) {
                      return _vm.handlerbtnsClick()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "icons",
                    class: _vm.isShow
                      ? "el-icon-arrow-up"
                      : "el-icon-arrow-down",
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "containerBox",
                  class: _vm.isShow ? "active" : "isActive",
                },
                [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c("div", { staticClass: "leftText1" }, [
                        _vm._v(" " + _vm._s(_vm.resourceName) + "****** "),
                      ]),
                      _vm.orderType != 5 && _vm.orderType != 1
                        ? _c("div", { staticClass: "leftText3" }, [
                            _c("div", { staticClass: "price" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "0.12rem" } },
                                [_vm._v("总价")]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "0.16rem" } },
                                [_vm._v(_vm._s(_vm.totalPrice))]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "0.12rem" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.datas.stockList[0].currency)
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.datas.productNameCn
                        ? _c("div", { staticClass: "leftText4" }, [
                            _vm._v(" " + _vm._s(_vm.datas.productNameCn) + " "),
                          ])
                        : _vm._e(),
                      _vm._l(_vm.datas.stockList, function (items, indexs) {
                        return _c("div", { key: indexs }, [
                          _vm.orderType != 5 && _vm.orderType != 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "leftText5",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "flex-wrap": "wrap",
                                  },
                                },
                                [
                                  _vm.datas.state === 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "0.05rem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(items.startDate) +
                                              " 至 " +
                                              _vm._s(
                                                _vm.addOneDay(items.endDate)
                                              )
                                          ),
                                        ]
                                      )
                                    : items.startDate == items.endDate
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "0.05rem",
                                          },
                                        },
                                        [_vm._v(_vm._s(items.endDate))]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "0.05rem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(items.startDate) +
                                              " 至 " +
                                              _vm._s(items.endDate)
                                          ),
                                        ]
                                      ),
                                  items.timeType == 4
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(items.timeTypeRemark[0]) +
                                            "-" +
                                            _vm._s(items.timeTypeRemark[1])
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.timeFrameCl(
                                              items.timeType,
                                              items.timeTypeRemark
                                            )
                                          )
                                        ),
                                      ]),
                                ]
                              )
                            : _c("div", { staticClass: "leftText5" }, [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "margin-right": "0.05rem" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(items.startTime)
                                      ) +
                                        " 至 " +
                                        _vm._s(
                                          _vm._f("dateFormat")(items.endTime)
                                        ) +
                                        " " +
                                        _vm._s(items.timeType)
                                    ),
                                  ]
                                ),
                              ]),
                          items.commodityNameCn || items.commodityNameEn
                            ? _c("div", { staticClass: "leftText4" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      items.commodityNameCn
                                        ? items.commodityNameCn
                                        : items.commodityNameEn
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "leftText6" }, [
                            _c("span", { staticClass: "leftText6-1" }, [
                              _vm._v("报价："),
                            ]),
                            _c("span", { staticClass: "leftText6-2" }, [
                              _vm._v(
                                _vm._s(items.salePrice) + _vm._s(items.currency)
                              ),
                            ]),
                            _c("span", { staticClass: "leftText6-3" }, [
                              _vm._v("/" + _vm._s(items.priceUnit) + " "),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "leftText6-3",
                                staticStyle: { "font-size": "20rpx" },
                              },
                              [
                                _vm._v(
                                  "（市价：" +
                                    _vm._s(
                                      items.storePrice ? items.storePrice : 0
                                    ) +
                                    _vm._s(items.currency) +
                                    "）"
                                ),
                              ]
                            ),
                            _vm.orderType == 5 && _vm.orderType == 1
                              ? _c("div", [
                                  items.recommendation
                                    ? _c("div", { staticClass: "leftText7" }, [
                                        _vm._v(
                                          " 推荐理由：" +
                                            _vm._s(items.recommendation) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                  items.cancelType
                                    ? _c("div", { staticClass: "leftText8" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.cancelTypeMap(items)) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm.orderType != 5 && _vm.orderType != 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "leftText6-2",
                                    staticStyle: {
                                      "margin-right": "12rpx",
                                      "font-weight": "400",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(items.saleNumber) +
                                        _vm._s(items.priceUnit) +
                                        " "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.calculateDaysDifference(
                                            items.startDate,
                                            items.endDate
                                          ) + 1
                                        )
                                      ),
                                    ]),
                                    _vm._v(_vm._s(items.useTime)),
                                  ]
                                )
                              : _vm._e(),
                            _vm.orderType != 5 && _vm.orderType != 1
                              ? _c("span", { staticClass: "leftText6-4" }, [
                                  _c("span", { staticClass: "leftText5" }, [
                                    _vm._v("共："),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (
                                          items.salePrice *
                                          (_vm.calculateDaysDifference(
                                            items.startDate,
                                            items.endDate
                                          ) +
                                            1) *
                                          items.saleNumber
                                        ).toFixed(2)
                                      ) +
                                      _vm._s(items.currency)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.datas.state == 2
                            ? _c("div", { staticClass: "leftText9" }, [
                                _vm._v(
                                  " 团队票 (20人(含)至" +
                                    _vm._s(items.cherish) +
                                    "）/ 单日票 / 营业时间: 以景点为准 / 单次入内 / "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      _vm.datas.recommendation
                        ? _c("div", { staticClass: "leftText7" }, [
                            _vm._v(
                              " 推荐理由：" +
                                _vm._s(_vm.datas.recommendation) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.orderType != 5 && _vm.orderType != 1
                        ? _c("div", { staticClass: "leftText8" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.cancelTypeMap(_vm.datas)) +
                                " / Option " +
                                _vm._s(
                                  _vm._f("dateFormatHms")(
                                    _vm.datas.saleOptionTime
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "right" }, [
                    _c(
                      "div",
                      { staticClass: "rightBtnList" },
                      _vm._l(_vm.swBtnList, function (item) {
                        return _c(
                          "div",
                          { key: item, staticClass: "rightBtns" },
                          [_vm._v(" " + _vm._s(item) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }